import { gql } from '@apollo/client';
import AddressFragment from "../Address";
import AddressSettingsFragment from "../AdressSettings";

const CompanyInvoiceInformationCardFragment = gql`
fragment CompanyInvoiceInformationCardFragment on CompanyInvoiceInformationCard {
	comment
	companyId
	companyName
	contact
	contactEmail
	contactTelephone
	costPlace1
	costPlace2
	customerNo
	distributionType
	gLN
	id
	interest
	invoiceEmail
	invoiceMessage
	isPrivatePerson
	orgNo
	ourReference
	yourReference
	paymentMethod
	paymentTerm
	paymentTermsDays
	reciverCompanyId
	vatRegNo
	currencyCode

	invoiceAddress {
		...AddressFields
	}
	deliveryAddress {
		...AddressFields
	}
	invoiceAddressSettings{
		...AddressSettingsFields
	}
	deliveryAddressSettings{
		...AddressSettingsFields
	}
}

${AddressFragment}
${AddressSettingsFragment}
`;

export default CompanyInvoiceInformationCardFragment;
